import gql from 'graphql-tag';

import type { BrandBrief } from 'src/data/brief';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';
import type { BackendQueryBrandBriefsArgs } from 'src/types/backend';

import { FRAGMENT_BRAND_BRIEF } from './schema';

const QUERY = gql`
  query BrandBriefs($brandVoiceId: ID!) {
    brandBriefs(brandVoiceId: $brandVoiceId) {
      ...BrandBrief
    }
  }
  ${FRAGMENT_BRAND_BRIEF}
`;

type Variables = Pick<BackendQueryBrandBriefsArgs, 'brandVoiceId'>;
type Result = BrandBrief[];

export const queryBrandBriefs = async (variables: Variables): Promise<Result | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  throwIfResultHasErrors(result);

  return getSingleProp<Result>(result.data);
};
